class UserInfo {
  constructor(data) {
    if (data == null) {
      this.UserId = -1;
      this.FirstName = null;
      this.LastName = null;
      this.DOB = null;
      this.Gender = 1;
      this.PhoneNumber = null;
      this.EMail = null;
      this.Password = null;
      this.SystemRole = null;
      this.UserLanguage = []
    } else {
      this.UserId = data.UserId;
      this.FirstName = data.FirstName;
      this.LastName = data.LastName;
      this.DOB = data.DOB;
      this.Gender = data.Gender;
      this.PhoneNumber = data.PhoneNumber;
      this.FatherName = data.FatherName;
      this.EMail = data.EMail;
      this.ProfilePhotoUrl = data.ProfilePhotoUrl;
      this.SystemRole = data.SystemRole;
      this.UserLanguage = data.UserLanguage;
    }
  }
}

export default UserInfo;
